import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import api from '../utils/api';
import { setCurrentUser } from '../utils/auth';
import './Login.css';

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await api.post('/login', values);
      if (response.data.access_token && response.data.user) {
        console.log('Login successful, token received:', response.data.access_token.substring(0, 20) + '...');  // 调试信息
        // 先保存用户信息，再调用onLogin
        setCurrentUser(response.data.user);
        onLogin(response.data.access_token, response.data.user);
      } else {
        message.error('登录响应数据不完整');
      }
    } catch (error) {
      console.error('Login error:', error);
      message.error(error.response?.data?.error || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card" title="博士学位授予单位与授予点建设进度管理系统">
        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名!' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="用户名" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码!' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              登录
            </Button>
          </Form.Item>
        </Form>
        <div style={{ marginTop: '20px', color: '#999', fontSize: '12px' }}>
          <p>默认管理员账号: admin / 123456</p>
        </div>
      </Card>
    </div>
  );
};

export default Login;

